import Badge from "components/badge";

const Header = ({ title, info, className = "", action }) => {
  return (
    <div className={`flex justify-between ${className}`}>
      <span className="body-14px-demibold text-gray-0">{title}</span>
      {info && <Badge type="more-Info" content={info} action={action} />}
    </div>
  );
};
export default Header;
